import {animate, keyframes, state, style, transition, trigger} from '@angular/animations';

export function errorFormAnimation(): any {
  return trigger('errorFormAnimation', [
    state('false', style({transform: 'translateX(0)'})),
    transition('false => *', [
      animate(500, keyframes([
        style({transform: 'translateX(0)',     offset: 0}),
        style({transform: 'translateX(-15px)', offset: 0.08}),
        style({transform: 'translateX(15px)', offset: 0.25}),
        style({transform: 'translateX(-15px)', offset: 0.41}),
        style({transform: 'translateX(15px)', offset: 0.58}),
        style({transform: 'translateX(-7px)', offset: 0.75}),
        style({transform: 'translateX(7px)',  offset: 0.92}),
        style({transform: 'translateX(0)',     offset: 1.0})
      ]))
    ])
  ]);
}
